<app-title-section></app-title-section>

<div class="card flex-grow mb-0" style=" margin-left: 15px; margin-right: 15px; background-color: transparent">
    <div class="content-area-wrapper "  style="height: 87vh ;  gap: 16px">
        <!-- Sidebar Left -->
        <div class="card" style="width: 400px">
            <app-layout-steps-client
                    [steps]="steps"
                    [currentStep]="currentStep"
                    (goBack)="retour()"
                    (stepSelected)="onTimelineStepSelected($event)">
            </app-layout-steps-client>
        </div>

        <!-- Content Right -->
        <div class="card content-right custom-scroll " style="overflow: auto;">

            <div class="content-wrapper p-0 content-right-r ">

            <div class="card-body ">
                    <div class="wizard-content">
                        <!-- Step 1: Type de client -->
                        <div *ngIf="currentStep === 0" class="step-form">
                            <div class="form-section rounded" style="height: 292px">
<div class="d-flex">


                                    <div class="option-card bordered pl-0" style="margin-right: 61px"
                                         [ngClass]="{'selected': productData.type === 'Materiel'}"
                                         [class.error-border]="showTypeError"
                                         (click)="selectClientType('Materiel')">
                                        <div class="card-content d-flex flex-column align-items-center justify-content-center">
                                            <div class="icon-title-container d-flex align-items-center justify-content-center">
                                                <i data-feather="user" size="30" class="mb-1"></i>
                                                <span style="font-size: 15px">Individuel</span>
                                            </div>
                                            <label class="container">
                                                <input
                                                        type="radio"
                                                        id="materiel"
                                                        name="productType"
                                                        value="Materiel"
                                                        [(ngModel)]="productData.type"
                                                        (change)="validateStep1()"
                                                        class="form-check-input"
                                                        [disabled]="mode === 'edit' || isSubmitting"
                                                >
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="option-card bordered" style="margin-left: 61px"
                                         [ngClass]="{'selected': productData.type === 'Service'}"
                                         [class.error-border]="showTypeError"
                                         (click)="selectClientType('Service')">
                                        <div class="card-content d-flex flex-column align-items-center justify-content-center">
                                            <div class="icon-title-container d-flex align-items-center justify-content-center">
                                                <i data-feather="briefcase" size="30" class="mb-1"></i>
                                                <span style="font-size: 15px">Professionnel</span>
                                            </div>
                                            <label class="container">
                                                <input
                                                        type="radio"
                                                        id="service"
                                                        name="productType"
                                                        value="Service"
                                                        [(ngModel)]="productData.type"
                                                        (change)="validateStep1()"
                                                        class="form-check-input"
                                                        [disabled]="mode === 'edit' || isSubmitting"
                                                >
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
</div>
                                <div>
                                    <div *ngIf="showTypeError"
                                         class="text-danger d-inline-flex small">
                                        <i data-feather="alert-triangle" class="me-2" size="13"
                                           style="margin-right: 6px"></i>
                                        Le type du client est obligatoire
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end mt-4">
                                <button [disabled]="isSubmitting" (click)="handleStepCompletion(0)"
                                        class="btn btn-primary" style="height: 40px">
                                    Continuer
                                </button>
                            </div>
                        </div>

                        <!-- Step 2: Informations du client -->
                        <div *ngIf="currentStep === 1" class="step-form">
                            <form #step2Form="ngForm" (ngSubmit)="handleStepCompletion(1)">
                                <div class="form-section rounded p-3 border-style" style="min-height: 331px; max-height: 600px">
                                    <div class="row g-3">
                                        <!-- Enterprise Details (Visible only for Professionnel) -->
                                        <div class="col-12" *ngIf="client.type === 'Professionnel'">
                                            <p class="details">Détails de l’entreprise</p>
                                            <div class="row g-3" style="margin-bottom: 34px">
                                                <div class="col-md-3">
                                                    <label class="form-label" for="enterpriseName">Nom de l'entreprise
                                                        <span class="req">*</span></label>
                                                    <input
                                                            type="text"
                                                            id="enterpriseName"
                                                            class="form-control"
                                                            placeholder="Entrez le nom de l'entreprise"
                                                            [(ngModel)]="client.nom_entreprise"
                                                            name="nom_entreprise"
                                                            required
                                                            [ngClass]="{'error-border': step2Errors.nom_entreprise && client.type === 'Professionnel'}"
                                                            (ngModelChange)="validateStep2()"
                                                    />
                                                    <div *ngIf="step2Errors.nom_entreprise && client.type === 'Professionnel' && (!client.nom_entreprise || client.nom_entreprise.trim() === '')"
                                                         class="text-danger d-flex small" style="margin-top: 4px;">
                                                        Le nom de l'entreprise est obligatoire
                                                    </div>
                                                </div>
                                                <div class="col-md-5">
                                                    <label class="form-label" for="taxId">Numéro d'identification
                                                        fiscale</label>
                                                    <input
                                                            type="text"
                                                            id="taxId"
                                                            class="form-control"
                                                            placeholder="Entrez le num d’identification fiscal"
                                                            [(ngModel)]="client.numero_identification_fiscale"
                                                            name="numero_identification_fiscale"
                                                            [disabled]="mode === 'edit'"
                                                            (ngModelChange)="validateStep2()"
                                                    />
                                                </div>
                                                <div class="col-md-4">
                                                    <label class="form-label" for="website">Site web</label>
                                                    <input
                                                            type="text"
                                                            id="website"
                                                            class="form-control"
                                                            placeholder="Entrez votre site web"
                                                            [(ngModel)]="client.site_web"
                                                            name="site_web"
                                                            [disabled]="mode === 'edit'"
                                                            (ngModelChange)="validateStep2()"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Civilité -->
                                        <div class="col-12">
                                            <p class="details1" *ngIf="client.type === 'Professionnel'">Détails de
                                                l’entreprise</p>
                                            <label class="form-label0">Civilité <span class="req">*</span></label>
                                            <div class="d-flex align-items-center gap-4">


                                                    <div>
                                                        <label class="container">
                                                            <input
                                                                    class="tva-radio"
                                                                    type="radio"
                                                                    name="civilite"
                                                                    value="Homme"
                                                                    id="homme"
                                                                    [(ngModel)]="client.civilite"
                                                                    (change)="validateStep2()"
                                                            />
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                    <span class="form-check-label ms-3" for="homme" style="margin: 9px 0 2px 6px; font-size: 15px">Homme</span>
                                                <div style="margin-left: 15px">
                                                    <label class="container">
                                                        <input
                                                                class="tva-radio"
                                                                type="radio"
                                                                name="civilite"
                                                                value="Femme"
                                                                id="femme"
                                                                [(ngModel)]="client.civilite"
                                                                (change)="validateStep2()"
                                                        />
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <span class="form-check-label ms-3" for="femme" style="margin: 9px 0 2px 6px; font-size: 15px">Femme</span>
                                            </div>
                                            <div *ngIf="step2Errors.civilite && !client.civilite"
                                                 class="text-danger d-flex small">
                                                La civilité est obligatoire
                                            </div>
                                        </div>

                                        <!-- Nom et Prénom and Identifiant on the same line -->
                                        <div class="col-12">
                                            <div class="row g-3">
                                                <div class="col-md-6">
                                                    <label class="form-label" style="margin-top: 24px;">Nom et Prénom
                                                        <span class="req">*</span></label>
                                                    <input
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Entrez le Nom et Prénom"
                                                            [ngClass]="{'error-border': step2Errors.nom_prenom}"
                                                            [(ngModel)]="client.nom_prenom" name="nom_prenom" required
                                                            (input)="step2Errors.nom_prenom = false; validateStep2()"
                                                            (ngModelChange)="validateStep2()"
                                                    />

                                                    <div *ngIf="step2Errors.nom_prenom"
                                                         class="text-danger d-flex small">
                                                        Le nom et prénom est obligatoire
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="form-label" style="margin-top: 24px;">Identifiant
                                                        Unique</label>
                                                    <input
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Entrez Identifiant"
                                                            [(ngModel)]="client.identifiant_unique"
                                                            name="identifiant_unique"

                                                            (ngModelChange)="validateStep2()"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Email -->
                                        <div class="col-12">
                                            <label class="form-label" style="margin-top: 24px;">Email </label>
                                            <input
                                                    type="email"
                                                    class="form-control"
                                                    placeholder="Entrez Email"
                                                    [(ngModel)]="client.emails[0].email"
                                                    name="email"
                                                    email
                                                    #emailControl="ngModel"
                                                    (ngModelChange)="validateStep2()"
                                            />

                                            <!-- Conteneur fixe pour l'erreur (espace toujours réservé) -->
                                            <div class="error-container m-0" style="min-height: 20px; margin-top: 4px;">
                                                <!-- Contenu d'erreur conditionnel (apparaît seulement si invalide ET touché) -->
                                                <div *ngIf="emailControl.invalid && (emailControl.dirty || emailControl.touched)"
                                                     class="text-danger">
                                                    <small *ngIf="emailControl.errors?.['email']">Format d'email
                                                        invalide (ex. : nom@exemple.com).</small>
                                                    <!-- Ajoutez d'autres erreurs si besoin, ex. required : -->
                                                    <!-- <small *ngIf="emailControl.errors?.['required']">L'email est requis.</small> -->
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-between align-items-center mt-4">
                                    <button
                                            type="button"
                                            class="btn btn-back"
                                            (click)="goBack()"
                                            style="background-color: rgba(19, 74, 211, 0.16) !important; color: rgba(19, 74, 211, 1);height: 40px"
                                    >
                                        <i class="bi bi-arrow-left me-2"></i> Retour
                                    </button>
                                    <div class="d-flex gap-2">
                                        <button
                                                type="button"
                                                class="btn btn-outline-primary"
                                                (click)="quickAdd()"
                                                [disabled]="!isStep1Valid || !isStep2Valid || isSubmitting"
                                                style="height: 40px"
                                        >
                                            {{ mode === 'edit' ? 'Mettre à jour rapidement' : 'Ajout Rapide' }}
                                        </button>

                                        <button
                                                type="button"
                                                class="btn btn-primary"
                                                (click)="handleStepCompletion(1)"
                                                [disabled]="isSubmitting"
                                                style="margin-left: 24px;height: 40px"
                                        >
                                            Continuer
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <!-- Step 3: Coordonnées -->
                        <div *ngIf="currentStep === 2" class="step-form">
                            <form #step3Form="ngForm" (ngSubmit)="handleStepCompletion(2)">
                                <div class="form-section rounded p-3 border-style">
                                    <div class="row p-0 m-0">
                                        <div class="col-md-10 p-0">
                                            <p class="titre1">Téléphones</p>
                                        </div>

                                        <div class="col-12 p-0" style="margin-top: 24px"
                                             *ngFor="let phone of client.telephones; let index = index; trackBy: trackByIndex">
                                            <div class="row align-items-start">

                                                <!-- Type téléphone -->
                                                <div class="col-md-4 p-0" style="margin-left: 14px">
                                                    <label class="form-label" [for]="'phoneType' + index">Type téléphone</label>
                                                    <select class="form-control phone-input phone-type"
                                                            [(ngModel)]="client.telephones[index].type"
                                                            [name]="'phoneType' + index"
                                                            [id]="'phoneType' + index"
                                                            [ngClass]="{'has-error': step3Errors.phones[index]?.type}"
                                                            (ngModelChange)="validatePhoneVisual()">
                                                        <option value="">Sélectionner</option>
                                                        <option value="mobile">Mobile</option>
                                                        <option value="fax">Fax</option>
                                                        <option value="whatsapp">WhatsApp</option>
                                                        <option value="viber">Viber</option>
                                                        <option value="support">Support</option>
                                                        <option value="fixe">Fixe</option>
                                                    </select>
                                                    <div class="text-danger small" *ngIf="step3Errors.phones[index]?.type">
                                                        {{ step3Errors.phones[index].type }}
                                                    </div>
                                                </div>

                                                <!-- Code pays -->
                                                <div class="col-md-2">
                                                    <label class="form-label" [for]="'phoneCode' + index">Code pays</label>
                                                    <input type="text"
                                                           class="form-control phone-input"
                                                           [(ngModel)]="client.telephones[index].code_pays"
                                                           [name]="'phoneCode' + index"
                                                           [id]="'phoneCode' + index"
                                                           placeholder="+216"
                                                           [ngClass]="{'has-error': step3Errors.phones[index]?.code_pays}"
                                                           (ngModelChange)="validatePhoneVisual()"
                                                           style="height: 43px;" />
                                                    <!-- On affiche l'erreur code pays avec le même groupe que le numéro -->
                                                    <div class="text-danger small" *ngIf="step3Errors.phones[index]?.code_pays">
                                                        {{ step3Errors.phones[index].code_pays }}
                                                    </div>
                                                </div>

                                                <!-- Numéro de téléphone -->
                                                <div class="col-md-5 p-0">
                                                    <label class="form-label" [for]="'phoneNumber' + index">Numéro de téléphone</label>
                                                    <input type="text"
                                                           class="form-control phone-input phone-number"
                                                           [(ngModel)]="client.telephones[index].num_tel"
                                                           [name]="'phoneNumber' + index"
                                                           [id]="'phoneNumber' + index"
                                                           placeholder="Ex: 22123456"
                                                           [ngClass]="{'has-error': step3Errors.phones[index]?.number}"
                                                           pattern="^[1-9][0-9]{7}$"
                                                           #phoneControl="ngModel"
                                                           (ngModelChange)="validatePhoneVisual()" />

                                                    <div class="text-danger small" *ngIf="step3Errors.phones[index]?.number">
                                                        {{ step3Errors.phones[index].number }}
                                                    </div>
                                                </div>

                                                <!-- Bouton supprimer/vide -->
                                                <div class="d-flex align-items-center " style="margin-top: 32px;margin-top: 24px">
                                                    <button type="button"
                                                            class="del-button p-0"
                                                            style="height: 43px; width: 43px;margin-bottom: 18px"
                                                            (click)="removeOrClearPhone(index)"
                                                            *ngIf="hasPhoneData(index) || client.telephones.length > 1"
                                                            [title]="client.telephones.length > 1 ? 'Supprimer' : 'Vider'">
                                                        −
                                                    </button>
                                                </div>
                                            </div>

                                            <!-- Ajouter un autre téléphone -->
                                            <div class="col-lg-12 p-0" style="margin-top: 24px" *ngIf="index === client.telephones.length - 1 && client.telephones.length < 5">
                                                <b style="color: rgba(19, 74, 211, 1); cursor: pointer;"
                                                   (click)="addPhone()">
                                                    Ajouter un numéro de téléphone
                                                </b>
                                            </div>
                                        </div>

                                        <!-- Si aucun téléphone -->
                                        <div  class="col-md-12 p-0" *ngIf="client.telephones.length === 0" style="margin-top: 15px;">
                                            <b style="color: rgba(19, 74, 211, 1); cursor: pointer;" (click)="addPhone()">
                                                Ajouter un numéro de téléphone
                                            </b>
                                        </div>
                                    </div>

                                    <!-- Address Section -->
                                    <div class="">
                                        <div class="col-md-10 p-0">
                                            <p class="titre1" style="margin-top: 34px">Adresses</p>
                                        </div>

                                        <div *ngFor="let addr of addressArray; let index = index">
                                            <!-- Cartes Facturation / Livraison (inchangées) -->
                                            <div class="row align-items-center mb-3">
                                                <!-- Adresse de facturation -->
                                                <div class="option-card2 bordered p-0 me-3"
                                                     style="min-height: 80px;"
                                                     [ngClass]="{
           'selected': addr.type === 'facturation',
           'has-error': hasAnyAddressFieldFilled(index) && !addr.type
         }"
                                                     (click)="addr.type = 'facturation'; validateAddressVisual(); validateStep3(); cd.detectChanges()">
                                                    <div class="radio-icon-container" style="margin: 20px 40px 0 50px;">
                                                        <label class="container p-0">
                                                            <input type="radio"
                                                                   class="tva-radio form-check-input radiobutton"
                                                                   value="facturation"
                                                                   [(ngModel)]="addr.type"
                                                                   [name]="'addressType_' + index"
                                                                   (ngModelChange)="validateAddressVisual(); validateStep3()">
                                                            <span class="checkmark"></span>
                                                        </label>
                                                        <span class="m-icon">
                <span data-feather="map-pin"></span>
            </span>
                                                        <span style="font-size: 15px; font-weight: 600; margin: 0 14px 0 10px">
                Adresse de facturation
            </span>
                                                    </div>
                                                    <p style="font-size: 13px; margin: 6px 14px 0 70px; text-align: left;">
                                                        Adresse où les factures seront envoyées
                                                    </p>
                                                </div>

                                                <!-- Adresse de livraison -->
                                                <div class="option-card2 bordered p-0"
                                                     style="min-height: 80px;"
                                                     [ngClass]="{
           'selected': addr.type === 'livraison',
           'has-error': hasAnyAddressFieldFilled(index) && !addr.type
         }"
                                                     (click)="addr.type = 'livraison'; validateAddressVisual(); validateStep3(); cd.detectChanges()">
                                                    <div class="radio-icon-container" style="margin: 20px 40px 0 50px;">
                                                        <label class="container p-0">
                                                            <input type="radio"
                                                                   class="tva-radio form-check-input radiobutton"
                                                                   value="livraison"
                                                                   [(ngModel)]="addr.type"
                                                                   [name]="'addressType_' + index"
                                                                   (ngModelChange)="validateAddressVisual(); validateStep3()">
                                                            <span class="checkmark"></span>
                                                        </label>
                                                        <span class="m-icon">
                <span data-feather="truck"></span>
            </span>
                                                        <span style="font-size: 15px; font-weight: 600; margin: 0 14px 0 10px">
                Adresse de livraison
            </span>
                                                    </div>
                                                    <p style="font-size: 13px; margin: 6px 14px 0 70px; text-align: left;">
                                                        Adresse où les commandes seront livrées
                                                    </p>
                                                </div>

                                                <!-- Bouton supprimer -->
                                                <div class="d-flex align-items-center justify-content-center" style="margin-left: 20px;">
                                                    <button type="button"
                                                            class="del-button p-0"
                                                            style="height: 43px; width: 43px;"
                                                            (click)="removeOrClearAddress(index)"
                                                            *ngIf="hasAddressData(index) || addressArray.length > 1"
                                                            title="{{ addressArray.length > 1 ? 'Supprimer' : 'Vider' }}">
                                                        −
                                                    </button>
                                                </div>
                                            </div>

                                            <!-- Message d'erreur type d'adresse -->
                                            <div class="text-danger small ms-3" *ngIf="step3Errors.addresses[index]?.type">
                                                {{ step3Errors.addresses[index].type }}
                                            </div>
                                            <!-- CHAMPS ADRESSE - avec bordure rouge + ! -->
                                            <div class="row g-4 d-flex"
                                                 style="width: 100%; margin-left: 2px; margin-top: 10px;">

                                                <!-- Pays -->
                                                <div class="col-md-4 p-0 position-relative">
                                                    <label class="form-label" [for]="'pays' + index">Pays</label>
                                                    <select class="form-control phone-input"
                                                            [(ngModel)]="addr.pays" [name]="'pays' + index"
                                                            [id]="'pays' + index"
                                                            [ngClass]="{'has-error': step3Errors.addresses[index]?.pays}"

                                                            (ngModelChange)="validateAddressVisual()">
                                                        <option value="">Sélectionner un pays</option>
                                                        <option value="France">France</option>
                                                        <option value="Belgique">Belgique</option>
                                                        <option value="Suisse">Suisse</option>
                                                        <option value="Maroc">Maroc</option>
                                                    </select>


                                                    <div class="text-danger small" *ngIf="step3Errors.addresses[index]?.pays">
                                                        {{ step3Errors.addresses[index].pays }}
                                                    </div>
                                                </div>

                                                <!-- Région -->
                                                <div class="col-md-4 position-relative">
                                                    <label class="form-label" [for]="'region' + index">Région</label>
                                                    <select class="form-control phone-input"
                                                            [(ngModel)]="addr.region" [name]="'region' + index"
                                                            [id]="'region' + index"
                                                            [ngClass]="{'has-error': step3Errors.addresses[index]?.region}"
                                                            (ngModelChange)="validateAddressVisual()">
                                                        <option value="">Sélectionner une région</option>
                                                        <option value="Île-de-France">Île-de-France</option>
                                                        <option value="Provence-Alpes-Côte d'Azur">Provence-Alpes-Côte
                                                            d'Azur
                                                        </option>

                                                    </select>
                                                    <div class="text-danger small" *ngIf="step3Errors.addresses[index]?.region">
                                                        {{ step3Errors.addresses[index].region }}
                                                    </div>

                                                </div>

                                                <!-- Code postal -->
                                                <div class="col-md-4 position-relative pr-0">
                                                    <label class="form-label" [for]="'codePostal' + index">Code
                                                        postal</label>
                                                    <input
                                                            type="text"
                                                            class="form-control phone-input"
                                                            [(ngModel)]="addr.code_postal"
                                                            [name]="'codePostal' + index"
                                                            placeholder="Entrez le code postal"
                                                            [ngClass]="{'has-error': step3Errors.addresses[index]?.code_postal}"
                                                            (ngModelChange)="validateAddressVisual()"
                                                    />


                                                    <div class="text-danger small" *ngIf="step3Errors.addresses[index]?.code_postal">
                                                        {{ step3Errors.addresses[index].code_postal }}
                                                    </div>
                                                </div>


                                            </div>
                                            <!-- Adresse complète -->
                                            <div class="col-12 position-relative p-0" style="margin-top: 24px">
                                                <label class="form-label" [for]="'adresse' + index">Adresse</label>
                                                <input
                                                        type="text"
                                                        class="form-control"
                                                        [(ngModel)]="addr.adresse"
                                                        [name]="'adresse' + index"
                                                        placeholder="Entrez Adresse"
                                                        [ngClass]="{'has-error': step3Errors.addresses[index]?.adresse}"
                                                        (ngModelChange)="validateAddressVisual()"
                                                />


                                                <div class="text-danger small" *ngIf="step3Errors.addresses[index]?.adresse">
                                                    {{ step3Errors.addresses[index].adresse }}
                                                </div>
                                            </div>
                                            <!-- Ajouter une autre adresse -->
                                            <div class="col-lg-12 p-0" style="margin-top: 24px"
                                                 *ngIf="index === addressArray.length - 1 && addressArray.length < 5">
                                                <a style="color: rgba(19, 74, 211, 1); cursor: pointer;"
                                                   (click)="addAddress()">
                                                    <b>Ajouter une adresse</b>
                                                </a>
                                            </div>
                                        </div>

                                        <!-- Si aucune adresse -->
                                        <div class="col-md-12 p-0" *ngIf="addressArray.length === 0"
                                             style="margin-top: 15px;">
                                            <a style="color: rgba(19, 74, 211, 1); cursor: pointer;"
                                               (click)="addAddress()">
                                                <b>Ajouter une adresse</b>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-between align-items-center mt-4">
                                    <button
                                            type="button"
                                            class="btn btn-back"
                                            (click)="goBack()"
                                            style="background-color: rgba(19, 74, 211, 0.16) !important; color: rgba(19, 74, 211, 1);height: 40px"
                                    >
                                        <i class="bi bi-arrow-left me-2"></i> Retour
                                    </button>
                                    <div class="d-flex gap-2">
                                        <button
                                                type="button"
                                                class="btn btn-outline-primary"
                                                (click)="quickAdd()"
                                                [disabled]="!isStep1Valid || !isStep2Valid || isSubmitting"
                                                style="height: 40px"
                                        >
                                            {{ mode === 'edit' ? 'Mettre à jour rapidement' : 'Ajout Rapide' }}
                                        </button>
                                        <button
                                                type="button"
                                                class="btn btn-primary"
                                                (click)="handleStepCompletion(2)"
                                                [disabled]="!isStep3Valid"
                                                style="margin-left: 24px; height: 40px"
                                        >
                                            Continuer
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <!-- Step 4: Informations supplémentaires -->
                        <div *ngIf="currentStep === 3" class="step-form">
                            <form #step4Form="ngForm" (ngSubmit)="handleStepCompletion(3)">
                                <div class="form-section rounded border-style" style="padding: 32px">
                                    <div style="padding-bottom: 24px">
                                        <label class="form-label">Encours autorisés (En TND)</label>
                                        <input
                                                type="text"
                                                class="form-control"
                                                [(ngModel)]="productData.authorizedOverdraft"
                                                name="EncoursAutorisés"
                                                placeholder="Entrez les encours autorisés"
                                                (ngModelChange)="validateStep4()"
                                        />
                                    </div>

                                    <div>
                                        <label class="form-label">Liste de prix</label>
                                        <div class="d-flex align-items-center gap-4 flex-wrap">
                                            <div class="form-check ms-3 me-1 p-0" *ngFor="let prix of prixList">

                                                <label class="container">
                                                    <input
                                                            class="tva-radio"
                                                            type="radio"
                                                            name="priceType"
                                                            [value]="prix.id"
                                                            [id]="'price_' + prix.id"
                                                            [(ngModel)]="productData.priceType"
                                                            (change)="togglePriceType(prix.id)"
                                                    />
                                                    <span class="checkmark"></span>
                                                </label>
                                                <label class="form-check-label p-0" [for]="'price_' + prix.id"
                                                       style="margin-right: 16px;">{{ prix.libelle }}</label>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <button type="button" class="add-button" (click)="openAddPriceModal()"
                                                        style="margin-left: 16px;">+
                                                </button>
                                                <button
                                                        type="button"
                                                        class="del-button ms-2 p-0"
                                                        (click)="clearListe(index)"
                                                        *ngIf="hasListeData(index)"
                                                        >
                                                    −
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div style="padding-top: 24px">
                                        <label class="form-label">Date limite de paiement</label>
                                        <div class="d-flex align-items-center gap-4 flex-wrap">
                                            <div class="form-check ms-3 me-1 p-0">
                                                <label class="container">
                                                    <input
                                                            class="tva-radio"
                                                            type="radio"
                                                            name="paymentPeriod"
                                                            value="jours"
                                                            id="jours"
                                                            [(ngModel)]="productData.paymentPeriod"
                                                            (change)="validateStep4()"
                                                    />
                                                    <span class="checkmark"></span>
                                                </label>
                                                <label class="form-check-label ms-2" for="jours" style="margin-right: 16px;">Jours</label>
                                            </div>
                                            <div class="form-check ms-3 me-1 p-0">
                                                <label class="container">
                                                    <input
                                                            class="tva-radio"
                                                            type="radio"
                                                            name="paymentPeriod"
                                                            value="mois"
                                                            id="mois"
                                                            [(ngModel)]="productData.paymentPeriod"
                                                            (change)="validateStep4()"
                                                    />
                                                    <span class="checkmark"></span>
                                                </label>
                                                <label class="form-check-label ms-2" for="mois" style="margin-right: 16px;">Mois</label>
                                            </div>
                                            <div class="form-check ms-3 me-1 p-0">

                                                <label class="container">
                                                    <input
                                                            class="tva-radio"
                                                            type="radio"
                                                            name="paymentPeriod"
                                                            value="année"
                                                            id="année"
                                                            [(ngModel)]="productData.paymentPeriod"
                                                            (change)="validateStep4()"
                                                    />
                                                    <span class="checkmark"></span>
                                                </label>
                                                <label class="form-check-label ms-2" for="année" style="margin-right: 16px;">Année</label>
                                            </div>

                                            <div class="d-flex align-items-center position-relative">
                                                <button type="button" class="del-button del1-button" (click)="decrementPaymentPeriod()">-</button>
                                                <input type="number" class="form-control h-38" [(ngModel)]="productData.paymentPeriodValue"
                                                       name="paymentPeriodValue" style="width: 80px; text-align: center;" min="0"
                                                       (ngModelChange)="validateStep4()" />
                                                <button type="button" class="add-button add1-button" (click)="incrementPaymentPeriod()">+</button>

                                                <!-- Bouton supprimer -->
                                                <button type="button" class="del-button ms-2 p-0"
                                                        (click)="clearDatePaiement()"
                                                        *ngIf="hasDatePaiementData()">
                                                    −
                                                </button>
                                            </div>
                                        </div>

                                        <!-- Messages d’erreur -->
                                        <div>
                                            <div *ngIf="showPaymentErrors">
                                                <!-- Erreur : type sélectionné mais pas de nombre -->
                                                <small class="text-danger d-block"
                                                       *ngIf="productData.paymentPeriod && (!productData.paymentPeriodValue || productData.paymentPeriodValue <= 0)">
                                                    <i data-feather="alert-triangle" class="me-1" size="14"></i>
                                                    Vous avez sélectionné un type de période mais pas de nombre. Veuillez compléter ou supprimer.
                                                </small>

                                                <!-- Erreur : nombre saisi mais pas de type -->
                                                <small class="text-danger d-block"
                                                       *ngIf="!productData.paymentPeriod && productData.paymentPeriodValue && productData.paymentPeriodValue > 0">
                                                    <i data-feather="alert-triangle" class="me-1" size="14"></i>
                                                    Vous avez entré un nombre mais pas sélectionné Jours, Mois ou Année. Veuillez compléter ou supprimer.
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-between align-items-center mt-4">
                                    <button
                                            type="button"
                                            class="btn btn-back"
                                            (click)="goBack()"
                                            style="background-color: rgba(19, 74, 211, 0.16) !important; color: rgba(19, 74, 211, 1);height: 40px"
                                    >
                                        <i class="bi bi-arrow-left me-2"></i> Retour
                                    </button>
                                    <button
                                            type="button"
                                            class="btn btn-primary"
                                            (click)="handleStepCompletion(3)"
                                            [disabled]="isSubmitting"
                                            style="margin-left: 24px;height: 40px"
                                    >
                                        Continuer
                                    </button>
                                </div>
                            </form>
                        </div>

                        <!-- Étape : Paramètres des données (GET param-tables / table client) -->
                        <div *ngIf="currentStep === 4" class="step-form tier-param-data-step">
                            <div class="p-2 border-style">
                                <h6 class="mb-3 size15" style="color: #2F2B3DE5"><b>Paramètres des données</b></h6>
                                <p class="size13 mb-3" style="color: #6E6B7B">
                                    Champs personnalisés pour les clients.
                                </p>
                                <div *ngIf="paramTablesLoading" class="text-muted mb-2">Chargement…</div>
                                <div
                                        *ngFor="let row of paramTableRows; let i = index"
                                        class="mb-3">
                                    <label class="form-label size13 mb-1 d-block">{{ row.libelle }}</label>
                                    <ng2-flatpickr
                                            *ngIf="row.type === 'date'"
                                            class="w-100"
                                            [name]="'clientParamDate' + i"
                                            [config]="clientParamDateFlatpickrOptions"
                                            [(ngModel)]="row.valeur"
                                            (ngModelChange)="onClientParamDateValeurChange(row, $event)"
                                            placeholder="jj/mm/aaaa"
                                    ></ng2-flatpickr>
                                    <ng-select
                                            *ngIf="row.type === 'select'"
                                            class="ng-select-custom w-100"
                                            [inputId]="'clientParamSelect' + i"
                                            [items]="getClientParamSelectOptions(row.param_table_id)"
                                            bindLabel="label"
                                            bindValue="value"
                                            [(ngModel)]="row.valeur"
                                            [name]="'clientParamSelect' + i"
                                            [clearable]="true"
                                            placeholder="Choisir une option"
                                            [notFoundText]="'Aucune option'"
                                    ></ng-select>
                                    <input
                                            *ngIf="row.type !== 'date' && row.type !== 'select'"
                                            type="text"
                                            class="form-control"
                                            [(ngModel)]="row.valeur"
                                            [name]="'clientParamValeur' + i"
                                            placeholder="Valeur"
                                            autocomplete="off">
                                </div>
                            </div>
                            <div class="d-flex justify-content-between align-items-center mt-4">
                                <button
                                        type="button"
                                        class="btn btn-back"
                                        (click)="goBack()"
                                        style="background-color: rgba(19, 74, 211, 0.16) !important; color: rgba(19, 74, 211, 1);height: 40px"
                                >
                                    <i class="bi bi-arrow-left me-2"></i> Retour
                                </button>
                                <button
                                        type="button"
                                        class="btn btn-primary"
                                        (click)="handleStepCompletion(4)"
                                        [disabled]="isSubmitting"
                                        style="margin-left: 24px;height: 40px"
                                >
                                    {{ mode === 'edit' ? 'Mettre à jour' : 'Valider' }}
                                </button>
                            </div>
                        </div>

                        <!-- Step 6: Terminé -->
                        <div *ngIf="currentStep === 5" class="step-form">
                            <div class="text-center form-section rounded p-4 border-style">
                                <div class="success-icon mb-2">
                                    <img src="./../../../../assets/images/logo/check.jpg" alt="check"
                                         style="width: 80px; height: auto;">
                                </div>
                                <h3 class="mb-3"
                                    style="font-size: 18px;font-weight: 700;color: rgba(47, 43, 61, 0.9)">{{ mode === 'edit' ? 'Client mis à jour avec succès' : 'Client ajouté avec succès' }}</h3>
                                <div class="d-flex justify-content-center gap-2">
                                    <button (click)="addNewProduct()" class="btn btn-outline-primary"
                                            style="margin-right: 6px;">Ajouter Un Nouveau Client
                                    </button>
                                    <!-- MODIFIÉ : viewProduct() → viewClient() pour appeler la bonne méthode -->
                                    <button (click)="viewClient()" class="btn btn-primary">Voir Client</button>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>


            </div>
        </div>
    </div>
</div>
<app-croud></app-croud>
